import { render, staticRenderFns } from "./MainButton.vue?vue&type=template&id=2457ea56&scoped=true&"
import script from "./MainButton.vue?vue&type=script&lang=js&"
export * from "./MainButton.vue?vue&type=script&lang=js&"
import style0 from "./MainButton.vue?vue&type=style&index=0&id=2457ea56&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2457ea56",
  null
  
)

export default component.exports